import React from 'react'

const NotFound = props => {
  return <div className='not-found'>{props.message}</div>
}

export default NotFound
